module.exports = __webpack_public_path__ + "static/media/22ESCWA5.97ed9505.jpg";